/* eslint-disable react-hooks/exhaustive-deps */
import { useNavigate } from 'react-router-dom';
import { CloseSvg } from 'utils/svgs';
import styles from './index.module.scss';
import UploadPreview from './UploadPreviewTable';
import { AppDispatch } from 'redux/store';
import { useDispatch, useSelector } from 'react-redux';
import { clearOcrData } from '../../redux/slices/OcrTimeLogsSlice';
import { useEffect, useState } from 'react';
import { invalidText } from 'utils/utils';

const UploadPreviewComponent = () => {
	const navigate = useNavigate();
	const { data } = useSelector((state: any) => state.ocrTimeLogs);
	const [supervisorName, setSupervisorName] = useState('');

	const dispatch = useDispatch<AppDispatch>();

	useEffect(() => {
		if (invalidText(data)) {
			navigate('/daily-attendance');
			return;
		}
		const res = data;

		setSupervisorName(res?.data?.supervisorName);
	}, []);

	return (
		<div className="modal-animation">
			<div className={styles['time-logs-preview']}>
				<div className={styles['time-logs-preview__header']}>
					<div className={styles['time-logs-preview__header__title']}>
						Time Logs Preview{' '}
						{invalidText(supervisorName)
							? ''
							: `(${supervisorName})`}
					</div>
					<div
						className={styles['time-logs-preview__header__actions']}
						onClick={() => {
							navigate('/daily-attendance');
							dispatch(clearOcrData());
						}}
					>
						<CloseSvg />
					</div>
				</div>
				<div className={styles['time-logs-preview__table']}>
					<UploadPreview />
				</div>
			</div>
		</div>
	);
};

export default UploadPreviewComponent;
